module.exports = __webpack_public_path__ + "static/awards-02-9729c573d69732e25b93f2a182466f1d.png";